import React from "react";

import clone_pelis from "../../../assets/img/portfolio/clone_pelis.png";
import skates from "../../../assets/img/portfolio/skates.png";
import journal from "../../../assets/img/portfolio/journal.jpg";

// import placeholder from "../../../assets/img/portfolio/placeholder_image.jpg";

const ProjectsPortfolio = () => {
	const projects = [
		{
			id: 1,
			preview: "https://develop-js.github.io/Clone_Repelis-ReactJs-/",
			code: "https://github.com/Develop-Js/Clone_Repelis-ReactJs-",
			title: "Clone Movies - Repelis",
			image: clone_pelis,
		},
		{
			id: 2,
			preview: "https://skates.vercel.app/",
			code: "https://github.com/Raulcmm/Skates",
			title: "Landing Skates",
			image: skates,
		},
		{
			id: 3,
			preview: "https://journal-rcm.vercel.app/auth/login",
			code: "https://github.com/Raulcmm/journal-app",
			title: "Journal App",
			image: journal,
		},
	];

	return (
		<section className="projects-portfolio main__container" id="projects">
			<h2>Projects</h2>
			<div className="projects-portfolio__grid">
				{projects.map((project) => (
					<article className="projects-portfolio__item" key={project.id}>
						<h3>{project.title}</h3>
						<img src={project.image} alt={project.title} />
						<div className="projects-portfolio__info">
							<a href={project.code} target="_blank" rel="noopener noreferrer">
								Code
							</a>
							<span>|</span>
							<a href={project.preview} target="_blank" rel="noopener noreferrer">
								Preview
							</a>
						</div>
					</article>
				))}
			</div>
		</section>
	);
};

export default ProjectsPortfolio;
